/**
 * Hands AfterShip's EDD widget the product it needs, without inlining the product JSON as
 * executable script.
 *
 * The widget reads `window._asProduct` when it boots. That global used to be set by
 * `<script> window._asProduct = {{ product | json }}</script>` repeated in every branch of the
 * aftership_estimate block, which shipped the same ~10 KB of product JSON twice and made the main
 * thread compile it as JavaScript. The section already emits that exact payload once as an inert
 * script[data-product-json] block for theme.js, so this file reads that instead of adding a copy.
 *
 * Load order matters: this file is deferred and rendered before the widget's own deferred
 * script, and deferred scripts run in document order, so the global is set first.
 *
 * Colour swaps are handled separately — collection-pdp-loader.js reassigns `window._asProduct`
 * from each template's data-aftership-product attribute.
 */
(function () {
  var node = document.querySelector('script[type="application/json"][data-product-json]');
  if (!node) return;

  try {
    window._asProduct = JSON.parse(node.textContent);
  } catch (e) {
    // Leave the global unset rather than half-set: the widget falls back to its product-id
    // attribute, and the next colour swap repopulates it.
  }
})();
